import { abortableFetch, useEventCallback } from '@eas/common-web';
import { createParticipantRequestTarget } from '@composite/participants/participant-create-utils';
import { EsFile, LegalAdviser } from '@models';
import { EvidenceApiUrl, ParticipantType } from '@enums';

export function useAddLegalAdviserDialog() {
  const callApi = useEventCallback(
    (formData: LegalAdviser, esFile: EsFile | undefined) => {
      const requestTarget = createParticipantRequestTarget(
        esFile,
        EvidenceApiUrl.ES_FILES
      );

      return abortableFetch(requestTarget.url, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          ...formData,
          type: ParticipantType.LEGAL_ADVISER,
          esFile: requestTarget.esFile,
        }),
      });
    }
  );

  return {
    callApi,
  };
}
